module.exports = {
  "option-list": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-around",
    "alignItems": "center",
    "height": "96",
    "backgroundColor": "#ffffff",
    "borderTopColor": "#e2e2e2",
    "borderTopWidth": "1"
  },
  "option-item": {
    "display": "flex",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "58",
    "height": "58",
    "borderRadius": "29",
    "backgroundColor": "#c7c7cc",
    "overflow": "hidden"
  },
  "option-item-current": {
    "backgroundColor": "#00A4F2"
  },
  "text": {
    "fontSize": "28",
    "color": "#ffffff"
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-182e5bf8!./~/weex-vue-loader/lib/selector.js?type=styles&index=0!./packages/dof-date-cycle-picker/option-list-circle.vue
// module id = 435
// module chunks = 0 1